import viewerState, { updateSegmentationVisibility } from "stores/viewer";
import {
  loadNiftiSegmentation,
  switchNiftiBase,
} from "./setupCornerstoneViewer";
import type { PetMask } from "./helpers/niftiDiscovery";

export const petMaskId = (url: string): string => `pet-mask:${url}`;

export async function selectPetViewerImage(
  url: string,
  modality: string,
): Promise<void> {
  const metadata = viewerState.instanceMetadata;
  const isCurrent = () => viewerState.instanceMetadata === metadata;
  viewerState.segmentsPerSeries = viewerState.segmentsPerSeries.map((s) => ({
    ...s,
    selected: false,
  }));
  await updateSegmentationVisibility();
  if (!isCurrent()) return;
  await switchNiftiBase(url, modality, isCurrent);
  if (!isCurrent()) return;
  viewerState.niftiBases[modality] = url;
  viewerState.niftiActiveModality = modality;
  viewerState.focusedMarkerCode = null;
}

export async function togglePetMask(
  mask: PetMask,
  selected: boolean,
): Promise<void> {
  const metadata = viewerState.instanceMetadata;
  const baseUrl = viewerState.niftiBases[mask.modality];
  const isCurrent = () =>
    viewerState.instanceMetadata === metadata &&
    viewerState.niftiActiveModality === mask.modality &&
    viewerState.niftiBases[mask.modality] === baseUrl;
  if (!baseUrl || !isCurrent()) return;
  const id = petMaskId(mask.url);
  if (selected) {
    await loadNiftiSegmentation(mask.url, {
      segmentationId: id,
      baseVolumeId: `nifti:${baseUrl}`,
      validatePetGeometry: true,
      isCurrent,
    });
    if (!isCurrent()) return;
    if (
      !viewerState.segmentsPerSeries.some((s) => s.representationUID === id)
    ) {
      viewerState.segmentsPerSeries.push({
        SegmentNumber: 1,
        SegmentLabel: mask.label,
        SegmentedPropertyTypeCodeSequence: [{ CodeValue: id }],
        representationUID: id,
        seriesUID: `nifti:seg:${mask.modality}`,
        _rgbColor: mask.color,
        selected: false,
      } as any);
    }
  }
  viewerState.segmentsPerSeries = viewerState.segmentsPerSeries.map((s) =>
    s.representationUID === id ? { ...s, selected } : s,
  );
  await updateSegmentationVisibility();
}
